import type CollapsibleListItem from '../../editor/formats/CollapsibleListItem';
import type { CollapsedHeader } from '../../editor/useHeaderCollapse';

const getReversedPrecedingItems = (
  element: HTMLElement,
  item: (CollapsedHeader | CollapsibleListItem)[],
) =>
  item
    .filter(
      ({ domNode }) =>
        element.compareDocumentPosition(domNode) & // eslint-disable-line no-bitwise
        Node.DOCUMENT_POSITION_PRECEDING,
    )
    .toReversed();

const isWithinCollapsedElement = (element: HTMLElement) =>
  !element.offsetParent;

const getCollapsedElementRect = (
  element: HTMLElement,
  collapsedItems: (CollapsedHeader | CollapsibleListItem)[],
) => {
  if (!isWithinCollapsedElement(element)) return null;

  const visibleCollapsedItems = collapsedItems.filter(
    (item) => !isWithinCollapsedElement(item.domNode),
  );

  const item = getReversedPrecedingItems(element, visibleCollapsedItems)[0];

  return item?.domNode.getBoundingClientRect() ?? null;
};

export default getCollapsedElementRect;
